import { FilterRule } from '../../rules/rules.types';

export const getText = (rule: FilterRule): string => {
    if (Array.isArray(rule.value)) {
        return `${rule.field} ${rule.operator} group`;
    }
    return `${rule.field} ${rule.operator} ${rule.value}`;
};
